import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Eye, ExternalLink } from "lucide-react";

export const DossierViewer = ({ dossier, onClose }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!dossier) { setUrl(""); return; }
    let u = "";
    api.get(`/dossiers/${dossier.id}/pdf`, { responseType: "blob" })
      .then((res) => { u = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })); setUrl(u); })
      .catch(() => setUrl("error"));
    return () => { if (u) window.URL.revokeObjectURL(u); };
  }, [dossier]);
  return (
    <Dialog open={!!dossier} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-5xl p-0 overflow-hidden" data-testid="dossier-viewer-dialog">
        <DialogHeader className="px-5 pt-5">
          <DialogTitle className="flex items-center gap-2 pr-6"><Eye className="h-5 w-5 text-blue-700" /> {dossier?.number} · {dossier?.title}</DialogTitle>
          <DialogDescription className="flex items-center justify-between gap-2">
            <span>Voorbeeld van het samengestelde dossier.</span>
            {url && url !== "error" && <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm text-blue-700 hover:underline" data-testid="dossier-viewer-newtab">Openen in nieuw tabblad <ExternalLink className="h-3.5 w-3.5" /></a>}
          </DialogDescription>
        </DialogHeader>
        <div className="h-[75vh] bg-slate-100 mt-3">
          {url === "error" ? <p className="p-6 text-sm text-red-600">Dossier kon niet worden geladen.</p>
            : url ? <iframe title="Dossier" src={url} className="w-full h-full border-0" data-testid="dossier-viewer-iframe" />
            : <p className="p-6 text-sm text-slate-500">Laden…</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
